var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("SidebarWidget", {
    attrs: {
      title: _vm.$gettext("Farbe"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c("studip-select", {
              attrs: {
                multiple: "",
                options: _vm.selectableColors,
                label: "name",
              },
              on: {
                input: _vm.onVueSelectInput,
              },
              scopedSlots: _vm._u([
                {
                  key: "open-indicator",
                  fn: function fn() {
                    return [
                      _c(
                        "span",
                        [
                          _c("studip-icon", {
                            attrs: {
                              shape: "arr_1down",
                              size: 10,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "option",
                  fn: function fn(option) {
                    return [
                      _c("span", {
                        staticClass: "vs__option-color",
                        style: {
                          "background-color": option.hex,
                        },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(option.name))]),
                    ]
                  },
                },
                {
                  key: "selected-option",
                  fn: function fn(option) {
                    return [
                      _c("span", {
                        staticClass: "vs__option-color",
                        style: {
                          "background-color": option.hex,
                        },
                        attrs: {
                          title: _vm.name,
                        },
                      }),
                    ]
                  },
                },
                {
                  key: "no-options",
                  fn: function fn() {
                    return [
                      _vm._v(
                        _vm._s(_vm.$gettext("Keine Auswahlmöglichkeiten"))
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.selectedColors,
                callback: function callback($$v) {
                  _vm.selectedColors = $$v
                },
                expression: "selectedColors",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }